import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { GoogleMap, LoadScript } from "@react-google-maps/api";  
 
const containerStyle = {
  width: "100%",
  height: "400px"
};

const center = {
  lat: 28.464615,  // Gurgaon location
  lng: 77.029919
};
function MyMap() {
  return (
    <LoadScript googleMapsApiKey="YOUR_API_KEY">
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={10}
      >
        {/* Map content */}
      </GoogleMap>
    </LoadScript>
  );
}

function Map() {
  return (

    <MapContainer center={[28.464615, 77.029919]} zoom={10} style={{ height: "100px" }}>
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Marker position={[28.464615, 77.029919]}>
        <Popup>
        </Popup>
      </Marker>
    </MapContainer>
  );
}

export default Map;




